import React from 'react';

const PageHero = ({ image, alt, title, subtitle }) => (
  <section
    data-testid="page-hero"
    style={{
      position: 'relative',
      padding: '6rem 0 4.5rem',
      textAlign: 'center',
      overflow: 'hidden',
      isolation: 'isolate'
    }}
  >
    <img
      src={image}
      alt={alt}
      decoding="async"
      style={{
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        objectPosition: 'center',
        zIndex: -2
      }}
    />
    <div
      aria-hidden="true"
      style={{
        position: 'absolute',
        inset: 0,
        background:
          'linear-gradient(180deg, rgba(253,252,249,0.93) 0%, rgba(253,252,249,0.84) 55%, rgba(253,252,249,0.96) 100%)',
        zIndex: -1
      }}
    />
    <div className="container">
      <h1 className="heading-hero" style={{ marginBottom: '1.5rem' }}>{title}</h1>
      {subtitle && (
        <p className="heading-subtitle" style={{ maxWidth: '800px', margin: '0 auto' }}>
          {subtitle}
        </p>
      )}
    </div>
  </section>
);

export default PageHero;
